import * as Sentry from "@sentry/react";
import { io } from "socket.io-client";
import prefilled from "./prefilled";
import { storage } from "./Storage";
import { tokenProcess } from "./Token";

export default class SocketCommunication {
  private socketUrl = "";
  private socket: any;

  constructor() {
    this.socketUrl = prefilled.socketUrl;

    console.log("Connecting to socket:", this.socketUrl);

    this.socket = io(this.socketUrl, {
      path: "/.sock",
      timeout: 10000,
      //transports: ["websocket", "polling"]
    });

    this.socket.on("connect", () => this.onConnect());
    this.socket.on("connect_error", (error: any) => {
      console.error("Socket connection error:", error);
      Sentry.captureException(error);

      // revert to classic upgrade
      this.socket.io.opts.transports = ["websocket", "polling"];
    });

    this.socket.on("disconnect", (reason: string) => {
      console.log("Socket disconnected:", reason);
    });
  }

  on(event: string, callback: Function) {
    this.socket.on(event, callback);
  }

  off(event: string, callback?: Function) {
    this.socket.off(event, callback);
  }

  emit(event: string, ...args: any) {
    this.socket.emit(event, ...args);
  }

  disconnect() {
    this.socket.disconnect();
  }

  private async onConnect() {
    try {
      console.log("Socket connected successfully");
      let greeting = await tokenProcess();

      try {
        this.socket.emit("token", JSON.stringify(greeting));
        console.log("Token emitted successfully");
      } catch (error) {
        console.error("Error on emitting token:", error);
        Sentry.captureException(error);
      }
    } catch (error) {
      console.error("Error in onConnect:", error);
      Sentry.captureException(error);
      storage.removeItem("PwToken");

      // Retry connection after delay
      setTimeout(() => {
        this.onConnect();
      }, 2000);
    }
  }
}
